import { LegalForm } from "@/queries/companies/fetch";
import { t } from "i18next";
import { z } from "zod";

export const addressSchema = z.object({
  addressLine1: z.string().min(1, {
    message: t("basic_data.validation.street_and_number_required"),
  }),
  postcode: z
    .string()
    .min(5, { message: t("basic_data.validation.postcode_required") }),
  city: z
    .string()
    .min(1, { message: t("basic_data.validation.city_required") }),
  addressLine2: z.string().optional(),
  country: z.string().default("DE"),
});

export type CompanyFormData = z.infer<typeof companyFormSchema>;

export const companyFormSchema = z.object({
  companyName: z
    .string()
    .min(1, t("basic_data.validation.company_name_required")),
  vatId: z
    .string()
    .refine((val) => !val || /^[A-Z]{2}[A-Z0-9]{8,12}$/.test(val), {
      message: t("basic_data.validation.vat_id_format"),
    })
    .optional(),
  companyDescription: z.string().min(1, {
    message: t("basic_data.validation.company_description_required"),
  }),
  inputTaxDeduction: z.boolean(),
  fiscalYearStartDay: z
    .number()
    .min(1, t("basic_data.validation.fiscal_year_start_day_invalid"))
    .max(31, t("basic_data.validation.fiscal_year_start_day_invalid"))
    .optional(),
  fiscalYearStartMonth: z
    .number()
    .min(1, t("basic_data.validation.fiscal_year_start_month_invalid"))
    .max(12, t("basic_data.validation.fiscal_year_start_month_invalid"))
    .optional(),
  thirteenBType: z.enum(["CONSTRUCTION", "STANDARD", "CLEANING"]).optional(),
  addresses: z.array(addressSchema),
  legalForm: z.nativeEnum(LegalForm, {
    required_error: t("basic_data.validation.legal_form_required"),
  }),
});
